import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ReqService } from '@core/services';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.reducer';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { selectHotelAvailability } from '@store/hotel-availability/hotel-availability.selectors';
import { HotelAvailability } from '@core/models/HotelAvailability/HotelAvailability.model';
import { IHotelStaticInfo } from '@core/models/HotelStaticInfo/hotelStaticInfo.interface';
import { BackgroundImageDirective } from '@shared/directives/background-image.directive';
import { MbBadgeModule, MbIconModule, MbCarouselModule, MbStarsRatingModule, MbIconTextModule } from '@am/moebius';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'am-header-mobile',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        MbBadgeModule,
        MbIconModule,
        MbCarouselModule,
        BackgroundImageDirective,
        MbStarsRatingModule,
        MbIconTextModule,
        AsyncPipe,
    ],
})
export class HeaderComponent implements OnInit {
  public hotelName: string;
  public isHotel: boolean;
  public stars: 1 | 2 | 3 | 4 | 5 = 1;
  public beds = 0;
  public maxRoomOccupancy = 0;
  public isDisney = false;

  private _images$: Subject<string[]> = new BehaviorSubject([]);
  private _dataLoaded$: Subject<boolean> = new BehaviorSubject(false);

  constructor(
    private readonly contextService: ReqService,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    const staticInfo: IHotelStaticInfo = this.contextService.getHotelStaticInfo();
    this.hotelName = staticInfo.name;
    this.stars = staticInfo.stars as any;
    this.isDisney = this.contextService.isDisneyHotel();
    const images = staticInfo.images
      .filter((element) => element)
      .map((element) => element.url);
    this._images$.next(images);

    this.store
      .select(selectHotelAvailability)
      .pipe(filter((hotel) => hotel !== null))
      .pipe(take(1))
      .subscribe((hotel: HotelAvailability) => {
        this.beds = hotel.beds;
        this.isHotel = !hotel.isHomestay;
        this.maxRoomOccupancy = hotel.max_room_occupancy;
        this._dataLoaded$.next(true);
      });
  }

  public get dataLoaded$(): Observable<boolean> {
    return this._dataLoaded$.asObservable();
  }

  public get images$(): Observable<string[]> {
    return this._images$.asObservable();
  }
}
